import { OOCanvasMenuItem } from "./oo-canvas-menu-item.model";
import { OOMenuItemCanvas } from "./oo-menu-item-canvas.model";
import { OOCanvasTimeRange } from "./OOCanvasTimeRange.entity";

export class OOCanvas {
	venueKey: number;
	canvasKey: number;
	name: string;
	displayName: string;
	sortOrder: number;
	online: boolean;
	min: number;
	max: number;
	menuItems?: OOCanvasMenuItem[];
	options?: any[];
	menuIds?: any[];
	description?: string;
	imageKey: string;
	defaultItemPriceNumber: number;
	defaultTaxable: boolean;
	defaultOnline: boolean;
	source: number;
	includedItemCanvas: boolean;
	hideImages: boolean;
	OOCanvasTimeRange: OOCanvasTimeRange[];
	sharedFrom: string; //venueKey_canvasKey

	ooCanvasMenuItems?: OOCanvasMenuItem[];

	ooMenuItemCanvas?: OOMenuItemCanvas;

	available: boolean;
	unavailableMessage: string;

	countOnline: number;

	subscriptionCanvas: boolean;
	subscriptionDescription: string;

	externalUrl?: string;

	public constructor(init?: Partial<OOCanvas>) {
		Object.assign(this, init);
	}
}
